import { IMallOrder } from '../type'
import { $post } from '@/api'
import $msg from '@/utils/message'
import { errorCallBack, formCreateTimeShow } from '@/utils'
import { IMallOrderDetail } from '../order-list/order-detail/type'
import { showLayer } from '@/utils/layer'
import MallOrderDeilver from '../order-deilver/order-deilver'
import React from 'react'

const mallOrderStatus = (
    order: IMallOrder.OrderInfo | IMallOrderDetail.Order,
    refresh: () => void,
    type?: 'accpet' | 'refuse',
) => {
    const deliverOrderReq = () =>
        $post({
            url: '/mall/orderdeliver',
            params: {
                order_id: order.order_id,
                order_type: order.order_type,
                delivery_type: order.delivery_type,
            },
        })
            .then(() => {
                $msg('success', '操作成功')
                refresh()
            })
            .catch(errorCallBack)

    const finishDeliverReq = () =>
        $post({
            url: '/mall/orderconfirmdelivery',
            params: {
                order_id: order.order_id,
                order_type: order.order_type,
                manual_finish: false,
            },
        })
            .then(() => {
                $msg('success', '操作成功')
                refresh()
            })
            .catch(errorCallBack)

    const solitaireOrderAccept = () =>
        $post({
            url: '/solitaire/solitaireorderaccept',
            params: {
                solitaire_order_id: order.order_id,
            },
        })
            .then(data => {
                $msg('success', '已接单')
                refresh()
            })
            .catch(errorCallBack)

    const refundAccpetReq = () =>
        $post({
            url: '/mall/orderrefundaccept',
            params: {
                order_id: order.order_id,
                order_type: order.order_type,
            },
        })
            .then(() => {
                $msg('success', '已退款')
                refresh()
            })
            .catch(errorCallBack)

    const refuseAccpetReq = () =>
        $post({
            url: '/mall/orderrefundrefuse',
            params: {
                order_id: order.order_id,
                order_type: order.order_type,
            },
        })
            .then(() => {
                $msg('success', '已拒绝')
                refresh()
            })
            .catch(errorCallBack)

    // const refundOrderReq = () =>
    //     $post({
    //         url: '/mall/orderrefundaccept',
    //         params: {
    //             order_id: order.order_id,
    //             order_type: order.order_type,
    //         },
    //     })
    //         .then(res => {
    //             $msg('success', '退款成功')
    //             refresh()
    //         })
    //         .catch(errorCallBack)

    if (order.status === 1 && order.refund_status === 0 && order.order_type !== 3) {
        return {
            text: '接单',
            action: solitaireOrderAccept,
        }
    }
    if (order.status === 2 && order.refund_status === 0) {
        if (order.delivery_type === 0) {
            return {
                text: '通知提货',
                action: deliverOrderReq,
            }
        } else {
            return {
                text: '发货',
                action: () => {
                    console.info(order.order_id, order.order_type)
                    showLayer(
                        <MallOrderDeilver orderId={order.order_id} orderType={order.order_type} refresh={refresh} />,
                    )
                },
            }
        }
    }
    if (order.status === 3 && order.delivery_type === 1 && order.refund_status === 0 && !order.is_shipping) {
        return {
            text: '确认送达',
            action: finishDeliverReq,
        }
    }
    if (order.status === 3 && order.delivery_type !== 0 && order.refund_status === 0 && order.is_shipping) {
        return {
            disabled: true,
            text: '等待客户确认收货',
            subText: `${formCreateTimeShow(order.create_time, 10)}后自动确认`,
            action: () => {},
        }
    }
    if (order.status === 3 && order.delivery_type === 0 && order.refund_status === 0 && !order.is_shipping) {
        return {
            text: '提货完成',
            action: finishDeliverReq,
        }
    }
    if (order.status === 3 && order.delivery_type === 0 && order.refund_status === 0 && order.is_shipping) {
        return {
            disabled: true,
            text: '等待客户确认收货',
            subText: `${formCreateTimeShow(order.create_time, 2)}后自动确认`,
            action: () => {},
        }
    }
    // if (order.refund_status === 1) {
    //     return {
    //         text: '确认退款',
    //         action: refundOrderReq,
    //     }
    // }
    if (order.status === 4) {
        if (type === 'accpet') {
            return {
                text: '确认退款',
                action: refundAccpetReq,
            }
        }

        return {
            text: '拒绝退款',
            action: refuseAccpetReq,
        }
    }
}

export default mallOrderStatus
